import { ScaleManager } from "../../managers/ScaleManager";
import { GameManager } from "../../managers/GameManager";
import { SceneManager } from "../../managers/SceneManager";
import { PreloaderScene } from "./PreloaderScene";
import { FpsCounterScene } from "./FpsCounterScene";
import { DevelopmentScene } from "./DevelopmentScene";
import { PauseScene } from "./PauseScene";
import { LocalizationManager } from "../../managers/LocalizationManager";
import { preloadDirectory } from "../../directory/assetDirectory";

export class StartScene extends Phaser.Scene{

  
    constructor(sceneConfig){
        super(sceneConfig);
      }

      preload(){
        let assetUrl = (<GameManager>GameManager.instance).assetUrl;

        for(let i = 0; i< preloadDirectory.images.length;i++)
        {
          this.load.image(preloadDirectory.images[i].id, assetUrl+preloadDirectory.images[i].src)
        }
        for(let i = 0; i< preloadDirectory.json.length;i++)
        {
          this.load.json(preloadDirectory.json[i].id, assetUrl+preloadDirectory.json[i].src)
        }
        for(let i = 0; i< preloadDirectory.atlas.length;i++)
        {
          this.load.atlas(preloadDirectory.atlas[i].id, assetUrl+preloadDirectory.atlas[i].spriteSheet, assetUrl+preloadDirectory.atlas[i].json)
        }
        
      }
  
      create() {
          let resize = function ()
          {
                console.log("Window.onResize!");
                let gm:GameManager = <GameManager>GameManager.instance;
                (<ScaleManager>ScaleManager.instance).scaleToElement(
                  gm.game!,
                  gm.cbnGameConfig!.gameElement!);
                  
          };
          window.onresize = resize;
          resize();
          LocalizationManager.cache = [];
          LocalizationManager.cache['en'] = ( (<any>this.cache).json.get('locale_en'));
          LocalizationManager.cache['es'] = ( (<any>this.cache).json.get('locale_es'));
          
          
          this.scene.add('FpsCounterScene',new FpsCounterScene({key:'FpsCounterScene'},1,0),true);
          this.scene.add('DevelopmentScene',new DevelopmentScene({key:'DevelopmentScene'},0,0,(<GameManager>GameManager.instance).assetUrl),true);
          SceneManager.changeScene(this,new PreloaderScene({key:'PreloaderScene'}));
      }
    
}